import { Bot, Link2 } from 'lucide-react'
import { CARD_STYLE, COLORS, INPUT_CLASS, INPUT_STYLE } from '../shared'
import { PERSONAS, getPersona } from '../personas'

export default function CreateAssistant({
  user,
  name,
  onNameChange,
  personaId,
  onPersonaChange,
  platformName,
}) {
  const persona = getPersona(personaId)

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-6 sm:gap-8">
      {/* Heading */}
      <div className="flex flex-col items-center gap-3 text-center">
        <span
          className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-[10px] font-semibold uppercase tracking-widest sm:text-[11px]"
          style={{
            background: 'rgba(173,52,254,0.12)',
            border: '1px solid rgba(173,52,254,0.25)',
            color: '#AD34FE',
          }}
        >
          <Bot className="h-3 w-3" />
          Agente IA
        </span>
        <h2
          className="text-2xl font-bold tracking-tight sm:text-4xl"
          style={{ color: COLORS.text, lineHeight: 1.1 }}
        >
          Crie o primeiro agente de{' '}
          <span
            style={{
              background: 'linear-gradient(90deg, #FE9F34, #AD34FE)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            {platformName || 'sua plataforma'}
          </span>
        </h2>
        <p
          className="max-w-xl text-sm leading-relaxed sm:text-base"
          style={{ color: COLORS.textMuted }}
        >
          Escolha o ponto de partida do agente. Ele ficará vinculado a este
          cliente e terá os próprios canais de atendimento.
        </p>
      </div>

      {/* Form card */}
      <div
        className="flex flex-col gap-5 rounded-2xl p-5 sm:gap-6 sm:rounded-3xl sm:p-8"
        style={CARD_STYLE}
      >
        <div className="flex flex-col gap-2">
          <label
            className="text-[10px] font-semibold uppercase tracking-wider sm:text-[11px]"
            style={{ color: 'rgba(255,255,255,0.4)' }}
          >
            Nome do agente
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="Ex: Atendimento Verboo"
            className={INPUT_CLASS}
            style={INPUT_STYLE}
          />
        </div>

        <div className="flex flex-col gap-3">
          <label
            className="text-[10px] font-semibold uppercase tracking-wider sm:text-[11px]"
            style={{ color: 'rgba(255,255,255,0.4)' }}
          >
            Persona
          </label>
          <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4 sm:gap-3">
            {PERSONAS.map((p) => {
              const Icon = p.icon
              const selected = personaId === p.id
              return (
                <button
                  key={p.id}
                  type="button"
                  onClick={() => onPersonaChange(p.id)}
                  className="group relative flex flex-col items-start gap-2 rounded-2xl p-4 text-left transition-all duration-200"
                  style={{
                    background: selected
                      ? 'rgba(173, 52, 254, 0.12)'
                      : 'rgba(255,255,255,0.03)',
                    border: selected
                      ? '1px solid rgba(173, 52, 254, 0.5)'
                      : '1px solid rgba(255,255,255,0.06)',
                    boxShadow: selected
                      ? '0 0 32px rgba(173,52,254,0.25)'
                      : 'none',
                  }}
                >
                  <div
                    className="flex h-9 w-9 items-center justify-center rounded-xl"
                    style={{
                      background: `${p.accent}18`,
                      border: `1px solid ${p.accent}30`,
                    }}
                  >
                    <Icon className="h-4 w-4" style={{ color: p.accent }} />
                  </div>
                  <span
                    className="text-sm font-semibold"
                    style={{ color: COLORS.text }}
                  >
                    {p.label}
                  </span>
                </button>
              )
            })}
          </div>
          {persona && (
            <p
              className="mt-1 text-xs leading-relaxed"
              style={{ color: 'rgba(255,255,255,0.5)' }}
            >
              {persona.sample}
            </p>
          )}
        </div>
      </div>

      {/* Hierarchy breadcrumb */}
      {platformName && name?.trim() && (
        <div className="flex items-center justify-center gap-2">
          <Link2
            className="h-3 w-3"
            style={{ color: 'rgba(255,255,255,0.2)' }}
          />
          <span
            className="text-[11px] font-medium"
            style={{ color: 'rgba(255,255,255,0.25)' }}
          >
            {platformName}
          </span>
          <span style={{ color: 'rgba(255,255,255,0.15)' }}>›</span>
          <span
            className="text-[11px] font-medium"
            style={{ color: 'rgba(173,52,254,0.6)' }}
          >
            {name.trim()}
          </span>
        </div>
      )}
    </div>
  )
}
